import React from 'react';
import { Space, VerticalSpace } from 'components/Space';
import { spacing } from 'constants/spacing';
import { Title } from 'components/Typography/Title';
import { Button } from 'components/Button';
import { WarningIcon } from 'components/Icon/Custom';
import { Text } from 'components/Typography';
import { commonProps } from '../constants';
import { IStatusChildrenProps } from '../types';
import { useStatusPageHandlers } from '../useStatusPageHandlers';
import { Wrapper } from './styled';

const NotFound: React.FC<IStatusChildrenProps> = ({ additionalDescription }) => {
  const { handleGoToMain } = useStatusPageHandlers();

  return (
    <Wrapper>
      <VerticalSpace size={20} {...commonProps}>
        <WarningIcon />

        <VerticalSpace size={spacing.md} {...commonProps}>
          <VerticalSpace size={spacing.sm} {...commonProps}>
            <VerticalSpace size={spacing.xxs} {...commonProps}>
              <Title level='h6'>Страница не найдена</Title>

              <VerticalSpace size={0} {...commonProps}>
                <Text color='gray650'>
                  Возможно, адрес введён с ошибкой или страница не существует.
                </Text>
                <Text color='gray650'>Проверьте ссылку или вернитесь на главную</Text>
              </VerticalSpace>

              {additionalDescription && (
                <Text color='gray650'>{additionalDescription}</Text>
              )}
            </VerticalSpace>
          </VerticalSpace>

          <Space>
            <Button variant='primary' onClick={handleGoToMain}>
              Перейти на главную
            </Button>
          </Space>
        </VerticalSpace>
      </VerticalSpace>
    </Wrapper>
  );
};

export default NotFound;
